const CodeName = {
  Header: 'header',
  Footer: 'footer',
};

export const CodeNameOptions = [
  { key: CodeName.Header, value: CodeName.Header, text: 'Header' },
  { key: CodeName.Footer, value: CodeName.Footer, text: 'Footer' },
];
